"use strict";
const guid_1 = require("../../common/src/guid");
/**
 * PlcToken
 */
class PlcToken {
    constructor(group, address, id, writeperm, addressType) {
        this.group = group;
        this.address = address;
        this.id = id;
        this.writeperm = writeperm;
        this.addressType = addressType;
    }
}
exports.PlcToken = PlcToken;
class PlcTextToken extends PlcToken {
    constructor(group, address, id, writeperm, addressType, defaultText, minval, maxval) {
        super(group, address, id, writeperm, addressType);
        this.group = group;
        this.address = address;
        this.id = id;
        this.writeperm = writeperm;
        this.addressType = addressType;
        this.defaultText = defaultText;
        this.minval = minval;
        this.maxval = maxval;
        this.guid = guid_1.Guid.newGuid();
        this.type = 'textbox';
    }
    toString() {
        return this.group + '~p~l~c~' + this.address + '~p~l~c~' + this.id + '~p~l~c~' + this.writeperm
            + '~p~l~c~' + this.addressType + '~p~l~c~' + this.defaultText;
    }
}
exports.PlcTextToken = PlcTextToken;
class PlcButtonToken extends PlcToken {
    constructor(
        // common values
        group, address, id, writeperm, addressType, 
        // specific values
        toggle, trueVal, falseVal, trueValMes, falseValMes) {
        super(group, address, id, writeperm, addressType);
        this.group = group;
        this.address = address;
        this.id = id;
        this.writeperm = writeperm;
        this.addressType = addressType;
        this.toggle = toggle;
        this.trueVal = trueVal;
        this.falseVal = falseVal;
        this.trueValMes = trueValMes;
        this.falseValMes = falseValMes;
        this.guid = guid_1.Guid.newGuid();
        this.type = 'button';
    }
    toString() {
        return this.group + '~p~l~c~' + this.address + '~p~l~c~' + this.id + '~p~l~c~' + this.writeperm
            + '~p~l~c~' + this.addressType;
    }
}
exports.PlcButtonToken = PlcButtonToken;
class PlcCheckboxToken extends PlcToken {
    constructor(
        // common values
        group, address, id, writeperm, addressType, 
        // specific values
        trueVal, falseVal, trueValMes, falseValMes) {
        super(group, address, id, writeperm, addressType);
        this.group = group;
        this.address = address;
        this.id = id;
        this.writeperm = writeperm;
        this.addressType = addressType;
        this.trueVal = trueVal;
        this.falseVal = falseVal;
        this.trueValMes = trueValMes;
        this.falseValMes = falseValMes;
        this.guid = guid_1.Guid.newGuid();
        this.type = 'checkbox';
    }
    toString() {
        return this.group + '~p~l~c~' + this.address + '~p~l~c~' + this.id + '~p~l~c~' + this.writeperm
            + '~p~l~c~' + this.addressType;
    }
}
exports.PlcCheckboxToken = PlcCheckboxToken;
class PlcRadioToken extends PlcToken {
    constructor(
        // common values
        group, address, id, writeperm, addressType, 
        // specific values
        values) {
        super(group, address, id, writeperm, addressType);
        this.group = group;
        this.address = address;
        this.id = id;
        this.writeperm = writeperm;
        this.addressType = addressType;
        this.values = values;
        this.guid = guid_1.Guid.newGuid();
        this.type = 'radio';
    }
    toString() {
        return this.group + '~p~l~c~' + this.address + '~p~l~c~' + this.id + '~p~l~c~' + this.writeperm
            + '~p~l~c~' + this.addressType;
    }
}
exports.PlcRadioToken = PlcRadioToken;
class PlcStateToken extends PlcToken {
    constructor(
        // common values
        group, address, id, writeperm, addressType, 
        // specific values
        trueVal, falseVal, trueValMes, falseValMes, interval) {
        super(group, address, id, writeperm, addressType);
        this.group = group;
        this.address = address;
        this.id = id;
        this.writeperm = writeperm;
        this.addressType = addressType;
        this.trueVal = trueVal;
        this.falseVal = falseVal;
        this.trueValMes = trueValMes;
        this.falseValMes = falseValMes;
        this.interval = interval;
        this.guid = guid_1.Guid.newGuid();
        this.type = 'state';
    }
    toString() {
        return this.group + '~p~l~c~' + this.address + '~p~l~c~' + this.id + '~p~l~c~' + this.writeperm
            + '~p~l~c~' + this.addressType;
    }
}
exports.PlcStateToken = PlcStateToken;
